import { borderRadius, margin, padding, position } from "polished";
import defaultImage from "../assets/expligo_wp2.png"
import { HorizontalLayout, VerticalLayout } from "../components/layout"
import { IconButton } from "./buttons";
import { useEffect, useState } from "react";
import avatar1 from "../assets/preview_target.webp";
import avatar2 from "../assets/preview_target-2.webp";
import avatar3 from "../assets/preview_target-3.webp";
import { min, set } from "date-fns";
import { TextAtom } from "./TextAtom";
export function VideoPlayer({ videoSrc, audio,audioSrc, className = "", avatarBackground, avatar, position }) {

  const avatarSrc = {1:avatar1, 2:avatar2, 3:avatar3}[avatar?.id] || "";
  const spotlightPosition = position === 1 ? "30% 50%" : position === 2 ? "50% 50%" : "70% 50%";
  const leftColor = avatarBackground?.colors?.[0];
  const centerColor = avatarBackground?.colors?.[1];
  const rightColor = leftColor;
  const backgroundGradient = `radial-gradient(circle 40rem at ${spotlightPosition}, ${leftColor} 0%, ${centerColor} 50%, ${rightColor} 100%)`;
  const avatarAlign = position === 1 ? "flex-start" : position === 2 ? "center" : "flex-end";

  return videoSrc ? (
    <VerticalLayout className="relative phone-avatar-video avatar-video">
      <video   onClick={(event) => event.stopPropagation()} controls className={`standard-shadow ${className}`} src={videoSrc} />
    </VerticalLayout>
  ) : (
    <VerticalLayout className={`relative ${className} phone-avatar-video avatar-preview-video`} style={{ background: backgroundGradient, alignItems: avatarAlign, }}>
      {avatarSrc && (<img src={avatarSrc} alt="Avatar" />)}
      {audio && <audio
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "auto",
          marginBottom: "1rem",
        }}
        onClick={(event) => event.stopPropagation()}
        controls> <source src={audioSrc} type="audio/mpeg" /></audio>}
    </VerticalLayout>
  )
}


export function VideoPlayerAssessment({ src, className = "", style, setPhoneCollapse, phoneCollapse, setCollapsed, collapsed, embedStructure, currentAssessment }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth < 768;
  useEffect(() => {
    if(isMobile){
      setPhoneCollapse(false);
    }else{
      setPhoneCollapse(true);
    }
  }, [isMobile]);
  useEffect(() => {
      const onResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, []);  
    const handleCollapse = () => {
      if(isMobile){
        setPhoneCollapse(!phoneCollapse);
        setCollapsed(!collapsed)
      }else{
        setCollapsed(!collapsed)
      }
    }
  const mobileSettings = phoneCollapse && isMobile
  if (!src) return <></>
  const showVideo = !collapsed && (!isMobile || !phoneCollapse);
  return (
    !phoneCollapse ? (
      <HorizontalLayout className="portrait-video-container" style={{ height: isMobile ? "25vh" : "100%", width: isMobile && "calc(100vw - 1rem)", borderRadius: ".5rem", position: "relative", }}> 
        <video onClick={(event) => event.stopPropagation()} controls className={`portrait-video standard-shadow ${className}`} src={src} />
        <IconButton style={{ position: "absolute", top: "0.5rem", right: "0.5rem" }} size={25} onClick={() => setPhoneCollapse(!phoneCollapse)} icon2={"x"} />
      </HorizontalLayout>
      ) : (
          <HorizontalLayout
            className={`avatar-video-container ${collapsed && "collapsed"} ${mobileSettings && "phone-collapsed"}`}
            style={{ borderRadius: isMobile ? ".5rem" : collapsed ? ".5rem" :  "0.5rem 0 0 0.5rem", width: isMobile && "calc(100vw - 1rem)", height: mobileSettings && "2rem", minHeight: mobileSettings && "2rem", position: isMobile && "relative" , margin: isMobile && ".5rem 0"}}>
            <SideIconBar collapsed={collapsed} onClick={() => handleCollapse()} phoneCollapse={phoneCollapse} isMobile={isMobile} />
            {showVideo && (
              <video
                controls
                disableFullscreen
                onClick={(event) => event.stopPropagation()}
                className={`standard-shadow ${className}`}
                style={{ borderRadius: !collapsed ? ".5rem" : "0 0.5rem 0.5rem 0", }}
                src={src}
              />
            )}
          </HorizontalLayout>
        )
  )
}

const SideIconBar = ({ onClick, collapsed, phoneCollapse, isMobile }) => (
  <VerticalLayout className="avatar-icon-container" style={{ justifyContent: "center", width: phoneCollapse && isMobile ? "100%" : "", height: phoneCollapse && isMobile ? "unset" :"100%", minHeight: phoneCollapse && isMobile ? "unset" : "15rem", zIndex: 3, margin: "1rem 0", opacity: phoneCollapse && isMobile ? 1 : "", flexDirection: phoneCollapse && isMobile ? "row" : "column", alignItems: "center", }}>
    <IconButton onClick={onClick} className={`no-margin avatar-icon-drop ${collapsed ? "collapsed" : ""} standard-margin-bottom`} size={25} icon2={phoneCollapse && isMobile ? (phoneCollapse ? "chevron-up" : "chevron-down") : (collapsed ? "chevron-left" : "chevron-right")} />
    {isMobile && phoneCollapse && <TextAtom title={"Video"} />}
  </VerticalLayout>
)